import { useState } from 'react';
import { creations } from '../data/creations';
import './NosCreations.css';

/* ─── Lightbox ─────────────────────────────────────────────── */
function Lightbox({ images, startIndex, onClose }) {
  const [current, setCurrent] = useState(startIndex);

  const prev = (e) => {
    e.stopPropagation();
    setCurrent((c) => (c - 1 + images.length) % images.length);
  };
  const next = (e) => {
    e.stopPropagation();
    setCurrent((c) => (c + 1) % images.length);
  };

  const handleKey = (e) => {
    if (e.key === 'ArrowLeft') setCurrent((c) => (c - 1 + images.length) % images.length);
    if (e.key === 'ArrowRight') setCurrent((c) => (c + 1) % images.length);
    if (e.key === 'Escape') onClose();
  };

  return (
    <div className="lightbox" onClick={onClose} onKeyDown={handleKey} tabIndex={0} autoFocus ref={(el) => el && el.focus()}>
      <button className="lightbox__close" onClick={onClose}>✕</button>
      <button className="lightbox__arrow lightbox__arrow--prev" onClick={prev}>‹</button>
      <div className="lightbox__img-wrap" onClick={(e) => e.stopPropagation()}>
        <img src={images[current]} alt={`Vue ${current + 1}`} className="lightbox__img" />
        <div className="lightbox__counter">{current + 1} / {images.length}</div>
      </div>
      <button className="lightbox__arrow lightbox__arrow--next" onClick={next}>›</button>
    </div>
  );
}

/* ─── Project Block (Like ArticleBlock in Press) ─────────────── */
function ProjectBlock({ project }) {
  const [lightbox, setLightbox] = useState(null); // null or index

  return (
    <article className="creation-project">
      <div className="creation-project__header">
        <div className="creation-project__meta">
          <span className="creation-project__label">Réalisation</span>
          <span className="creation-project__count">{project.images.length} Photos</span>
        </div>
        <h2 className="creation-project__title">{project.name}</h2>
        <div className="creation-project__divider" />
      </div>

      <div className="creation-project__gallery">
        {project.images.map((img, i) => (
          <div
            key={i}
            className="creation-project__thumb"
            onClick={() => setLightbox(i)}
          >
            <img src={img} alt={`${project.name} – photo ${i + 1}`} />
            <div className="creation-project__thumb-overlay">
              <span>+</span>
            </div>
          </div>
        ))}
      </div>

      {lightbox !== null && (
        <Lightbox
          images={project.images}
          startIndex={lightbox}
          onClose={() => setLightbox(null)}
        />
      )}
    </article>
  );
}

/* ─── Page ─────────────────────────────────────────────────── */
export default function NosCreations() {
  return (
    <main className="creations-page">
      {/* Banner */}
      <div className="creations-page__banner">
        <div className="creations-page__banner-content">
          <span className="section-label">Chez nos clients</span>
          <h1 className="creations-page__title">Nos Créations Chez Vous</h1>
          <div className="creations-page__divider" />
          <p className="creations-page__subtitle">
            Découvrez nos réalisations installées chez nos clients — résidences privées, boutiques, espaces professionnels et bien-être à travers la Tunisie et le monde.
          </p>
        </div>
      </div>

      {/* Projects list */}
      <div className="creations-page__body">
        {creations.map((project, i) => (
          <ProjectBlock key={i} project={project} />
        ))}
      </div>

      {/* CTA */}
      <div className="creations-page__cta">
        <span className="section-label">Votre Projet</span>
        <h3 className="creations-page__cta-title">Vous souhaitez donner vie à votre intérieur ?</h3>
        <a href="/contact" className="btn-outline">Contactez-Nous</a>
      </div>
    </main>
  );
}
